import { toast } from "react-toastify";
import { ToastType } from "../../../utils/types";
import { ToastIcon } from "../../icons/toastIcon";

export const getToastColor = (type: ToastType) => {
  switch (type) {
    case "success":
      return "border-pry-dark-green-300/20 bg-light-green-bg-400";
    case "error":
      return "border-error-200/20 bg-light-red-bg-50";
    case "warning":
      return "border-warning-yellow/20 bg-warning-yellow-bg-50";
    default:
      return "border-info-purple/20 bg-info-purple-bg";
  }
};

const ToastMessage = ({
  title,
  message,
  type,
}: {
  title: string;
  message: string;
  type: ToastType;
}) => {
  return (
    <div className="flex items-center md:items-start gap-3">
      <ToastIcon type={type} />

      <p className="flex flex-col">
        <span className="text-pry-dark-green-400 text-base font-medium max-md:hidden">
          {title}
        </span>
        <span className="text-sm text-pry-dark-green-400 md:text-pry-dark-green-400/60 max-md:font-medium">
          {message}
        </span>
      </p>
    </div>
  );
};

export const doNotification = (
  message: string,
  type: ToastType = "success"
) => {
  switch (type) {
    case "success":
      toast.success(
        <ToastMessage title="Success" message={message} type={type} />
      );
      break;
    case "error":
      toast.error(<ToastMessage title="Error" message={message} type={type} />);
      break;
    case "warning":
      toast.warning(
        <ToastMessage title="Warning" message={message} type={type} />
      );
      break;
    default:
      toast.info(
        <ToastMessage title="Information" message={message} type={type} />
      );
  }
};
